const CART_SESSION_KEY = 'shop-cart-session-id';

export function getCartSessionId() {
  const existingSession = window.localStorage.getItem(CART_SESSION_KEY);

  if (existingSession) {
    return existingSession;
  }

  const nextSession =
    window.crypto?.randomUUID?.() ||
    `session-${Date.now()}-${Math.random().toString(16).slice(2)}`;

  window.localStorage.setItem(CART_SESSION_KEY, nextSession);
  return nextSession;
}
